import React from "react"
import "./index.scss"

const Chip = React.forwardRef((props, ref) => {
  function setClassName() {
    let className = "chip"
    if (props.outlined) className += ` chip--outlined`
    if (props.outlined) className += ` chip--read-only`
    if (props.selected)
      className += ` chip--selected chip--selected--${props.selectedColor}`
    if (props.disabled) className += " chip--disabled"
    return className
  }

  return (
    <div
      className={setClassName()}
      disabled={props.disabled}
      onClick={props.onClick}
      ref={ref}
    >
      {props.children}
    </div>
  )
})

export default Chip
